import React from "react";
import { Loader2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
function ScheduleInspectionForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="19209" className="bg-primary/10 border border-primary/20 rounded-[24px] p-8 text-center animate-in fade-in zoom-in duration-300">
        <h3 className="text-2xl font-bold text-primary mb-2">Solicitud Enviada</h3>
        <p className="text-muted-foreground mb-6">{successMessage}</p>
        <Button onClick={() => window.location.reload()} className="bg-secondary text-secondary-foreground hover:bg-secondary/90 font-semibold rounded-full">
          Nueva Inscripción
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
      {}
      <FormField control={control} name="property_address" rules={{
      required: "La dirección es obligatoria"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-muted-foreground">Dirección de Residencia</FormLabel>
            <FormControl>
              <Input placeholder="Calle, Número, Ciudad" className="bg-card border-input text-foreground shadow-inner placeholder:text-muted-foreground focus-visible:ring-secondary focus-visible:border-secondary" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {}
        <FormField control={control} name="name" rules={{
        required: "El nombre es obligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-muted-foreground">Nombre Completo</FormLabel>
              <FormControl>
                <Input placeholder="Juan Pérez" className="bg-card border-input text-foreground shadow-inner placeholder:text-muted-foreground focus-visible:ring-secondary focus-visible:border-secondary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="phone" rules={{
        required: "El teléfono es obligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-muted-foreground">Teléfono de Contacto</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="(000) 000-0000" className="bg-card border-input text-foreground shadow-inner placeholder:text-muted-foreground focus-visible:ring-secondary focus-visible:border-secondary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="email" rules={{
        required: "El correo es obligatorio",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Correo electrónico inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-muted-foreground">Correo Electrónico</FormLabel>
              <FormControl>
                <Input type="email" placeholder="juan@ejemplo.com" className="bg-card border-input text-foreground shadow-inner placeholder:text-muted-foreground focus-visible:ring-secondary focus-visible:border-secondary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="service_type" rules={{
        required: "Por favor selecciona un curso"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-muted-foreground">Curso de Interés</FormLabel>
              <FormControl>
                <select className="flex h-9 w-full rounded-md border border-input bg-card px-3 py-1 text-base shadow-inner transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-secondary/50 focus-visible:border-secondary disabled:cursor-not-allowed disabled:opacity-50 md:text-sm text-foreground" {...field}>
                  <option value="" disabled className="bg-card text-muted-foreground">Selecciona un curso</option>
                  <option value="Técnico electricista" className="bg-card">Técnico electricista</option>
                  <option value="Auxiliar Administrativo Contable" className="bg-card">Auxiliar Administrativo Contable</option>
                  <option value="Barbería" className="bg-card">Barbería</option>
                </select>
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      {}
      <FormField control={control} name="preferred_date" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-muted-foreground">Fecha Preferida de Inicio <span className="text-muted-foreground/60 text-xs ml-1">(Opcional)</span></FormLabel>
            <FormControl>
              <Input type="date" className="bg-card border-input text-foreground shadow-inner placeholder:text-muted-foreground focus-visible:ring-secondary focus-visible:border-secondary" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {}
      <FormField control={control} name="additional_details" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-muted-foreground">Comentarios Adicionales <span className="text-muted-foreground/60 text-xs ml-1">(Opcional)</span></FormLabel>
            <FormControl>
              <textarea className="flex min-h-[80px] w-full rounded-md border border-input bg-card px-3 py-2 text-base shadow-inner placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-secondary/50 focus-visible:border-secondary disabled:cursor-not-allowed disabled:opacity-50 md:text-sm text-foreground" placeholder="Cualquier información adicional que desees compartir..." {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-3 bg-destructive/10 border border-destructive/20 rounded text-destructive text-sm">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full bg-secondary text-secondary-foreground hover:scale-[1.02] transition-transform duration-200 shadow-[0_0_20px_rgba(234,179,8,0.4)] font-bold h-11 text-base mt-2">
        {isSubmitting ? <>
            <Loader2 className="animate-spin mr-2 size-5" />
            Procesando...
          </> : 'Inscribirme Ahora'}
      </Button>
      <p className="text-muted-foreground mt-4 text-xs font-light font-sans text-center">
        Tus datos están protegidos y solo se utilizarán para fines académicos.
      </p>
    </Form>;
}
export default function ScheduleInspection() {
  return <section id="formulario-de-inscripción" className="bg-background text-foreground py-[120px] px-4 md:px-6 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-30" />
      
      <div className="max-w-[600px] mx-auto relative z-10">
        <div className="text-center mb-8">
          <p className="font-mono text-primary text-sm tracking-wider mb-2">PROCESO DE ADMISIÓN 2024</p>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground tracking-tight font-sans uppercase">Inicia tu Carrera hoy</h2>
          <p className="text-muted-foreground mt-3">
            Completa el formulario para recibir información detallada sobre nuestros programas y asegurar tu cupo.
          </p>
        </div>

        <div className="bg-card/80 backdrop-blur-md border-2 border-primary/20 rounded-[24px] p-6 md:p-8 shadow-xl">
          <FormProvider formId="enrollment_form_academy" sectionName="formulario-de-inscripción" defaultValues={{
          name: "",
          phone: "",
          email: "",
          property_address: "",
          service_type: "",
          preferred_date: "",
          additional_details: ""
        }} validationRules={{
          name: {
            required: true
          },
          phone: {
            required: true
          },
          email: {
            required: true,
            pattern: "email"
          },
          property_address: {
            required: true
          },
          service_type: {
            required: true
          }
        }} submitText="Inscribirme Ahora" successMessage="¡Tu solicitud ha sido recibida! Un asesor académico se pondrá en contacto contigo a la brevedad.">
            <ScheduleInspectionForm />
          </FormProvider>
        </div>
      </div>
    </section>;
}